import React, {useContext} from 'react';
import cl from './IsNewTemplate.module.css';
import {useTranslation} from "react-i18next";
import {useShipmentApi} from "../../../../../../app/api/shipment";
import {GridContext} from "../../../../../../components/ui/Grid/Telerik/Grid";
import globeLoader from '../../../../../../assets/images/loader.gif';
import {toast} from "react-toastify";
import {ResponseResultCode} from "../../../../../../app/enums/ResponseResultCode";

const IsNewTemplate = (props: any) => {
    const {t} = useTranslation();
    let isNew = null;
    if (props.children !== undefined && props.children !== null) {
        isNew = props.children.toString().toLowerCase() === 'true';
    }

    const {
        markShipmentsAsViewed: {mutation: markShipmentsAsViewed},
        maskShipmentsAsUnViewed: {mutation: markShipmentsAsUnViewed}
    } = useShipmentApi();

    const {
        updateRowData
    } = useContext(GridContext);

    const markAsViewed = async () => {
        if (props.dataItem === null ||
            props.dataItem === undefined ||
            props.dataItem.shipmentId === undefined ||
            props.dataItem.shipmentId === null) {
            return;
        }

        try {
            updateRowData({
                ...props.dataItem,
                isRowLoading: true,
            });

            const response = await markShipmentsAsViewed({
                ids: [props.dataItem.shipmentId]
            });

            if (response && response.status === 200 &&
                response.data && response.data.resultCode === ResponseResultCode.Ok) {
                updateRowData({
                    ...props.dataItem,
                    isRowLoading: false,
                    isNew: false
                });
            }
        } catch {
            toast.error('Unable to change viewed state of shipment');

            updateRowData({
                ...props.dataItem,
                isRowLoading: false,
            });
        }
    }

    const markAsUnViewed = async () => {
        if (props.dataItem === null ||
            props.dataItem === undefined ||
            props.dataItem.shipmentId === undefined ||
            props.dataItem.shipmentId === null) {
            return;
        }

        try {
            updateRowData({
                ...props.dataItem,
                isRowLoading: true,
            });

            const response = await markShipmentsAsUnViewed({
                ids: [props.dataItem.shipmentId]
            });

            if (response && response.status === 200 &&
                response.data && response.data.resultCode === ResponseResultCode.Ok) {
                updateRowData({
                    ...props.dataItem,
                    isRowLoading: false,
                    isNew: true
                });
            }
        } catch {
            toast.error('Unable to change viewed state of shipment');

            updateRowData({
                ...props.dataItem,
                isRowLoading: false,
            });
        }
    }

    if (props.dataItem.isRowLoading !== undefined && props.dataItem.isRowLoading !== null &&
        props.dataItem.isRowLoading === true) {
        return (
            <td {...props.tdProps}
                colSpan={1}>
                <img src={globeLoader} style={{width: '10px'}} alt={'Loading...'} title={'Loading...'}/>
            </td>
        )
    }

    return (
        <td {...props.tdProps}
            colSpan={1}>
            <span className={`w100 h100 block ${cl.container} grid-prevent-selection`}>
                {isNew !== null && isNew === true &&
                    <button className={`${cl.button} grid-prevent-selection shipment-grid-mark-as-viewed-btn ${cl.new}`}
                            title={t(`shipment.grid.un-viewed-shipment`)}
                            onClick={markAsViewed}></button>
                }
                {isNew !== null && isNew === false &&
                    <button
                        className={`${cl.button} grid-prevent-selection shipment-grid-mark-as-un-viewed-btn ${cl.old}`}
                        title={t("shipment.grid.viewed-shipment")}
                        onClick={markAsUnViewed}></button>
                }
            </span>
        </td>
    );
};

export default IsNewTemplate;
